export const replaceUrlParams = (history, params, replaceAll = true, state = null) => () => {
  let urlParams = params;
  if (!replaceAll) {
    const currentParams = history?.location?.search ?? '';
    urlParams = `${currentParams}${params}`;
  }

  if (state) {
    history.replace(urlParams, state);
  } else {
    history.replace(urlParams);
  }
};
export const redirectFromLogin = config => () => {
  const currentHref = globalThis.location.href;
  const urlLogin = config?.baseLoginUrl;

  globalThis.location.href = `${urlLogin}?next=${currentHref}`;
};
